import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { DropOffIcon, MissclickIcon, TimeIcon } from '@app-velocity/icons';

export type ConfusionDetailsProps = {
  confusion?: {
    totalClicks: number;
    missClicks: number;
    duration: number;
    dropoffs: number;
    weight: number;
    missClicksRatio: number;
    dropOffsRatio: number;
  };
  avgPageDuration: number;
};

const MetricsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  flex: '0 1 auto',
  height: theme.spacing(20),
}));

const SingleMetric = styled('div')(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  svg: {
    fill: '#1b1b1b',
  },
}));

export const ConfusionDetails = ({
  confusion,
  avgPageDuration,
}: ConfusionDetailsProps) => {
  const { t } = useI18n();

  if (!confusion) return null;

  const { missClicksRatio, dropOffsRatio, duration } = confusion;

  return (
    <MetricsContainer>
      {missClicksRatio >= 0.2 ? (
        <SingleMetric>
          <MissclickIcon />
          <strong>{Math.round(missClicksRatio * 100)}%</strong>
          {t('prototypes:report.confusions.metrics.high_missclick_rate')}
        </SingleMetric>
      ) : null}
      {dropOffsRatio >= 0.2 ? (
        <SingleMetric>
          <DropOffIcon />
          <strong>{Math.round(dropOffsRatio * 100)}%</strong>
          {t('prototypes:report.confusions.metrics.high_drop_off_rate')}
        </SingleMetric>
      ) : null}
      {duration > avgPageDuration * 1.5 ? (
        <SingleMetric>
          <TimeIcon />
          <strong>{duration.toFixed(0)}s</strong>
          {t('prototypes:report.confusions.metrics.long_dwell_time')}
        </SingleMetric>
      ) : null}
    </MetricsContainer>
  );
};
